module.exports = __webpack_public_path__ + "img/izidok_loginpage_promo_2_rev3.c0d99b21.jpg";